import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-view-pending',
    templateUrl: './pending.component.html',
    styleUrls: ['./pending.component.css'],
})
export class PendingComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
